import { Button, Empty } from "antd";

import { DownloadOutlined } from "@ant-design/icons";
import React from "react";
import Text from "antd/lib/typography/Text";
import { useSendTextLead } from "../../../../GlobalHooks/useSendLead";
import { useTheme } from "../../../../Styles/ThemeHook";

export interface PropFloorPlansProps {
	id: number;
	files: FileType[];
	isProject: boolean;
}

export function PropertyModalFloorPlans({ id, files, isProject }: PropFloorPlansProps) {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const { theme } = useTheme();

	const { sendLead, loading: loadingSendLead } = useSendTextLead({
		property_id: id,
		entity_type: isProject ? "PROJECT" : "PROPERTY",
		financing_information: false,
		isAutoGenerated: false,
		source: 14,
		message: "Me gustaría ver los planos de la propiedad",
	});

	if (files.length == 0) {
		return (
			<Empty
				imageStyle={{ height: 50, opacity: 0.9 }}
				description={
					<Text style={{ color: theme.colors.textInverseColor }}>
						{"La propiedad no tiene planos"}
					</Text>
				}>
				<Button
					loading={loadingSendLead}
					onClick={() =>
						sendLead().then(response => {
							handleClickShowNotification({
								message: response.success
									? "Consulta enviada"
									: "Error al enviar la consulta",
								type: response.success ? "success" : "error",
							});
						})
					}
					ghost>
					{"Pedir planos"}
				</Button>
			</Empty>
		);
	}

	return (
		<>
			{files.map((o, i) => {
				return (
					<div key={i}>
						<Text>{o.title == "" ? "Plano " + (i + 1) : o.title}</Text>
						<a href={o.file} target={"_blank"}>
							<Button type="primary" shape="circle" icon={<DownloadOutlined />} />
						</a>
					</div>
				);
			})}
		</>
	);
}
